<template>
  <div>
    <!-- 작성자정보 -->
    <div v-if="visibleTitle">
      <div>
        <h5><i class="dot"></i>작성자 정보</h5>
      </div>
    </div>
    <div class="createdby mt-4 mb-28px">
      <div>
        <b>부서명</b>
        <p>
          {{ form.division ? form.division : "-" }}
        </p>
      </div>
      <div>
        <b>팀명</b>
        <p>
          {{ form.section ? form.section : "-" }}
        </p>
      </div>
      <div>
        <b>직책</b>
        <p>
          {{ form.rank ? form.rank : "-" }}
        </p>
      </div>
      <div>
        <b>작성자</b>
        <p>
          {{ form.writer_name ? form.writer_name : "-" }}
        </p>
      </div>
      <div>
        <b>작성일</b>
        <p>{{ form.date ? form.date : "-" }}</p>
      </div>
    </div>

    <!-- 사업장정보 -->
    <div v-if="useFieldInfo">
      <div v-if="visibleTitle">
        <div>
          <h5><i class="dot"></i>{{ title }}</h5>
        </div>
      </div>
      <div class="writeGridContainer mt-4">
        <slot name="after-custom-row"></slot>
        <fragment v-for="type in formTypes" :key="type" v-if="type !== 'field_name' || (type === 'field_name' && visibleFieldForm)">
          <div v-if="type === 'field_name' && visibleFieldForm" class="grid-column-content" vs-align="center">
            <!-- fieldRequired 가 true 이면 작성 화면에서만 라벨 뒤에 "(필수)" 를 붙인다 (인쇄 시에는 붙이지 않는다) -->
            <div class="title">{{ fieldRequired && !isPrint ? `${fieldTitle}(필수)` : fieldTitle }}</div>
            <div v-if="isPrint" class="print-input">{{ form.field_name }}</div>
            <field-selector v-else class="w-full" v-model="form.field_id" :field-name="form.field_name" :readonly="board.readonly" :show-all="showAll" @select="onSelectFieldSelector" :use-tab-codes="useTabCodes" />
          </div>
          <div v-if="type === '부서명_과'" class="grid-column-content" vs-align="center">
            <div class="title">
              {{ !!typeslabel.부서명_과 ? typeslabel.부서명_과 : "부서명" }}
            </div>
            <div v-if="isPrint" class="print-input">
              {{ form.부서명_과 }}
            </div>
            <ml-input v-else class="w-full" v-model="form.부서명_과" :readonly="readonly" />
          </div>
          <div v-if="type === 'department'" class="grid-column-content" vs-align="center">
            <div class="title">
              {{ !!typeslabel.department ? typeslabel.department : "소속명" }}
            </div>
            <div v-if="isPrint" class="print-input">
              {{ form.department }}
            </div>
            <ml-input v-else class="w-full" v-model="form.department" :readonly="readonly" />
          </div>
          <div v-if="type === 'com_name'" class="grid-column-content" vs-align="center">
            <div class="title">
              {{ !!typeslabel.com_name ? typeslabel.com_name : "팀명" }}
            </div>
            <div v-if="isPrint" class="print-input">
              {{ form.com_name }}
            </div>
            <company-selector v-else-if="enabled" class="w-full" v-model="form.company_id" :company-name="form.com_name" :readonly="readonly" @select="onSelectCompanySelector" />
            <ml-input v-else class="w-full" v-model="form.com_name" :readonly="readonly" />
          </div>
          <div v-if="type === 'manager_name'" class="grid-column-content" vs-align="center">
            <div class="title">
              {{ !!typeslabel.manager_name ? typeslabel.manager_name : "담당주무관" }}
            </div>
            <div v-if="isPrint" class="print-input">
              {{ form.manager_name }}
            </div>
            <company-selector v-else-if="enabled" class="w-full" v-model="form.company_id" :company-name="form.manager_name" :readonly="readonly" @select="onSelectCompanySelector" />
            <ml-input v-else class="w-full" v-model="form.manager_name" :readonly="readonly" />
          </div>
          <!--        수정일 추가-->
          <div v-if="type === 'updated_at'" class="grid-column-content" vs-align="center">
            <div class="title">
              {{ !!typeslabel.updated_at ? typeslabel.updated_at : "최종수정일" }}
            </div>
            <div v-if="isPrint" class="print-input">
              {{ form.updated_at }}
            </div>
            <date-selector v-else class="w-full" v-model="form.updated_at" :readonly="readonly" />
          </div>
        </fragment>

        <div v-for="option of options" :key="option.label" v-show="option.type !== 'alert'">
          <!-- option.required 가 true 이면 작성 화면에서만 라벨 뒤에 "(필수)" 를 붙인다 (인쇄 시에는 붙이지 않는다) -->
          <div class="title">{{ option.required && !isPrint ? `${option.label}(필수)` : option.label }}</div>
          <div v-if="isPrint">
            <div v-if="option.type === 'daterang'" class="print-input">{{ form[`${option.label}`]["sDate"] ? form[`${option.label}`]["sDate"] : "" }} ~ {{ form[`${option.label}`]["eDate"] ? form[`${option.label}`]["eDate"] : "" }}</div>
            <div v-else class="print-input">
              {{ form[`${option.label}`] }}
            </div>
          </div>
          <div v-else class="overflow-visible">
            <date-selector v-if="option.type === 'date'" class="w-full" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly || option.readonly" />
            <ml-input v-else-if="option.type === 'text'" class="w-full" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly || option.readonly" />
            <disaster-class-selector v-else-if="option.type === 'disaster'" class="w-full" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly" :multiple="option.multiple" />
            <time-selector v-else-if="option.type === 'time'" class="w-full flex-1" v-model="form[`${option.label}`]" :readonly="board.readonly" />
            <vs-select v-else-if="option.type === '요일'" class="w-full flex-1" autocomplete v-model="form[`${option.label}`]">
              <vs-select-item v-for="option in ['월요일', '화요일', '수요일', '목요일', '금요일', '토요일', '일요일']" :key="option" :text="option" :value="option" />
            </vs-select>
            <vs-select v-else-if="option.type === '날씨'" class="w-full flex-1" autocomplete v-model="form[`${option.label}`]">
              <vs-select-item v-for="option in ['맑음', '흐림', '눈', '비']" :key="option" :text="option" :value="option" />
            </vs-select>

            <date-selector-rang v-else-if="option.type === 'daterang'" v-model="form[`${option.value || option.label}`]" :readonly="board.readonly || option.readonly" />
          </div>
          <!-- <disaster-class-selector class="w-full" :readonly="board.readonly" :multiple="multipleDisaster" /> -->
        </div>
        <div v-if="!isPrint && optionsType.includes('alert')" class="xl:col-span-12">
          <div class="title">알림 대상자 선택</div>
          <AlertUserSelector class="w-full" v-model="form.notification" :readonly="board.readonly" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FieldSelector from "@/components/selector/FieldSelector";
import DateSelector from "@/components/selector/DateSelector";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import AlertUserSelector from "@/components/selector/AlertUserSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import config from "/public/config";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";

export default {
  name: "FieldSelectModule",
  components: {
    DateSelectorRang,
    CompanySelector,
    TimeSelector,
    DisasterClassSelector,
    DateSelector,
    FieldSelector,
    AlertUserSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    enabled: Boolean,
    // 사업장 정보 사용 여부
    useFieldInfo: {
      type: Boolean,
      default: true,
    },
    fieldName: String,
    // 사업명·시설물명(field_name) 이 필수 항목이면 true. 작성 화면의 라벨에 "(필수)" 가 표시된다
    fieldRequired: {
      type: Boolean,
      default: false,
    },
    visibleTitle: {
      type: Boolean,
      default: () => true,
    },
    visibleFieldForm: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: () => "사업장정보",
    },
    options: {
      type: Array,
      default: () => [],
    },
    date: {
      type: String,
      default: () => {
        return new Date().format("yyyy-MM-dd");
      },
    },
    types: Array,
    typeslabel: {
      type: Object,
      default: () => {
        return {
          field_name: "사업장명",
          department: "소속명",
          com_name: "팀명",
          manager_name: "담당 주무관",
          부서명_과: "부서명",
        };
      },
    },
    useTabCodes: Array,
    // 참여 여부와 상관없이 모든 사업장을 조회하도록하는 경우
    showAll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
    // 화면에 표시되는 사업장 항목 이름 (프로젝트 종류에 따라 사업명·시설물명). 게시판의 필수값 안내 문구에도 쓴다
    fieldTitle() {
      return this.fieldName ? this.fieldName : this.fieldLabel || "";
    },
    fieldLabel() {
      if (this.projectInfo.project_type === "총괄관리") {
        //ProjectId = 1
        return "사업장명";
      } else if (this.projectInfo.project_type === "내부종사자") {
        //ProjectId = 2
        return "사업장명";
      } else if (this.projectInfo.project_type === "도급") {
        //ProjectId = 3
        return "사업명";
      } else if (this.projectInfo.project_type === "발주") {
        //ProjectId = 4
        return "사업장명";
      } else if (this.projectInfo.project_type === "중대시민재해") {
        //ProjectId = 5
        return "시설물명";
      }
    },
    optionsType() {
      return this.options.map((op) => op.type);
    },
    readonly() {
      return !this.enabled || this.board.readonly;
    },
    formTypes() {
      if (this.types) return this.types;
      if (parseInt(this.projectId) === 2) {
        return ["field_name", "부서명_과", "com_name", "manager_name"];
      }
      return ["field_name", "department", "com_name", "manager_name"];
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        // 작성자 정보 등 공통 필드는 field_id 유무와 관계없이 저장값을 복원한다.
        // (사업장 선택이 없는 게시판은 저장된 stdInfo 에 field_id 가 없어 아래 else 로직을 타지 않기 때문에,
        //  이 블록이 없으면 저장된 작성자 정보가 복원되지 않는다.)
        // 값이 있을 때만 대입하여 신규 작성 시 board 로 채운 값이 지워지지 않도록 한다.
        if (this.value) {
          if (this.value.date) this.form.date = this.value.date;
          if (this.value.division) this.form.division = this.value.division;
          if (this.value.department) this.form.department = this.value.department;
          if (this.value.section) this.form.section = this.value.section;
          if (this.value.rank) this.form.rank = this.value.rank;
          if (this.value.writer_name) this.form.writer_name = this.value.writer_name;
          if (this.value.com_name) this.form.com_name = this.value.com_name;
          if (this.value.manager_name) this.form.manager_name = this.value.manager_name;
          if (this.value.부서명_과) this.form.부서명_과 = this.value.부서명_과;
        }

        if (typeof this.value === "undefined" || typeof this.value.field_id === "undefined") {
          this.form.field_id = 0;
        } else {
          this.form.date = this.value.date;
          this.form.field_id = this.value.field_id;
          this.form.field_name = this.value.field_name;
          this.form.project_name = this.value.project_name;
          this.form.field_address = this.value.field_address;
          this.form.부서명_과 = this.value.부서명_과;
          this.form.division = this.value.division;
          this.form.department = this.value.department;
          this.form.section = this.value.section;
          this.form.com_name = this.value.com_name;
          this.form.manager_name = this.value.manager_name;
          this.form.rank = this.value.rank;
          this.form.writer_name = this.value.writer_name;
          this.form.검토일 = this.value.검토일;
          this.form.조사일 = this.value.조사일;
          this.form.점검일 = this.value.점검일;
          this.form.보수일 = this.value.보수일;
          this.form.진단일 = this.value.진단일;
          this.form.보강일 = this.value.보강일;
          this.form.교체일 = this.value.교체일;
          this.form.평가일 = this.value.평가일;
          this.form.점검장소 = this.value.점검장소;
          this.form.보수장소 = this.value.보수장소;
          this.form.재해형태 = this.value.재해형태;
          this.form.진단장소 = this.value.진단장소;
          this.form.보강장소 = this.value.보강장소;
          this.form.교체장소 = this.value.교체장소;
          this.form.평가자 = this.value.평가자;
          this.form.공정내용 = this.value.공정내용;

          this.form.총원 = this.value.총원;
          this.form.작업내용 = this.value.작업내용;
          this.form.점검시간 = this.value.점검시간;
          this.form.작업명 = this.value.작업명;

          this.form.notification = this.value.notification;

          this.form.관리주체 = this.value.관리주체;
          this.form.관리방법 = this.value.관리방법;
          this.form.소관부서 = this.value.소관부서;
          this.form.담당주무관 = this.value.담당주무관;

          // updated_at 추가
          const postId = this.$route.params.postId;
          const boardList = this.$store.state.board.list;
          for (const boardData of boardList) {
            if (boardData.id === postId) {
              this.form.updated_at = boardData.updated_at;
            }
          }
        }

        for (const option of this.options) {
          if (this.value) {
            this.form[`${option.label}`] = this.value[`${option.label}`] ? this.value[`${option.label}`] : "";
          } else {
            this.form[`${option.label}`] = "";
          }
        }
      },
    },
    "form.field_id": {
      immediate: true,
      handler(fieldId) {
        if (fieldId && !this.form.부서명_과) {
          this.$store.dispatch("project/LOAD_FIELD", { postId: fieldId }).then((res) => {
            if (res) {
              const meta = JSON.parse(res.meta);
              this.form.부서명_과 = meta.com_name;
            }
          });
        }
      },
    },
    form: {
      immediate: false,
      deep: true,
      handler() {
        this.$emit("input", this.form);
      },
    },
    projectInfo: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.project_name = value.field_name;
      },
    },
    board: {
      immediate: true,
      deep: true,
      handler(board) {
        // post 를 불러왔을 경우에는
        // post 에 저장되어 있는 데이터를 사용하기 때문에,
        // board 의 정보로 데이터를 저장하지 않는다.
        // 수정 모드(postId 존재)에서는 저장된 stdInfo 가 항상 우선이므로,
        // 뒤늦게 발생하는 board 변경으로 작성자 정보가 현재 로그인 사용자로 덮어써지지 않도록 한다.
        const postId = this.$route.params.postId;
        if (!postId && (!this.value || !this.value.com_name)) {
          if (board) {
            const author = board.author || board.writer;
            this.form.department = author.department;
            this.form.company_id = author.company_id;
            this.form.section = author.section;
            this.form.rank = author.rank;
            this.form.writer_name = author.name;
            if (author.meta) this.form.division = author.meta.division;
          }

          if (typeof this.value === "undefined" || typeof this.value.field_id === "undefined") {
            this.form.field_id = 0;
          } else {
            this.form.field_id = this.value.field_id;
            this.form.field_name = this.value.field_name;
            this.form.field_address = this.value.address;
          }

          for (const option of this.options) {
            if (this.value) {
              this.form[`${option.label}`] = this.value[`${option.label}`] ? this.value[`${option.label}`] : "";
            } else {
              this.form[`${option.label}`] = "";
            }
          }
        }

        // 부서명(division)은 문서에 저장된 값이 없을 경우 작성자 정보의 meta.division 으로 보완한다.
        // 수정 모드에서는 반드시 문서 작성자(board.author)의 값을 사용해야 하며,
        // 현재 로그인 사용자(board.writer)로 채우면 안 된다. (board.author 는 checkPermission 이후 비동기로 채워짐)
        // 저장된 division 은 덮어쓰지 않으며, 작성자 정보가 없으면 그대로 비워 둔다.
        if (board && !this.form.division) {
          const author = postId ? board.author : board.writer;
          if (author && author.meta && author.meta.division) {
            this.form.division = author.meta.division;
          }
        }
      },
    },
  },
  data() {
    return {
      hostname: config.HOST_NAME,
      form: {
        field_id: 0,
        project_name: "",
        field_name: "",
        field_address: "",
        manager_name: "",
        division: "",
        department: "",
        company_id: 0,
        section: "",
        com_name: "",
        rank: "",
        writer_name: "",
        date: this.date,
        부서명_과: "",
        검토일: "",
        조사일: "",
        점검일: "",
        보수일: "",
        진단일: "",
        보강일: "",
        교체일: "",
        평가일: "",
        점검장소: "",
        보수장소: "",
        재해형태: "",
        진단장소: "",
        보강장소: "",
        교체장소: "",
        평가자: "",
        공정내용: "",

        총원: "",
        작업내용: "",
        점검시간: "",
        작업명: "",

        scale1: "",
        scale2: "",
        scale3: "",
        cat1: "", // 구분
        cat2: "", // 종류
        cat3: "", // 세분류
        classification: "",

        updated_at: "",

        notification: [],
      },
    };
  },

  methods: {
    initForm(value) {
      // 작성자 정보 등 공통 필드는 field_id 유무와 관계없이 저장값을 복원한다.
      // (사업장 선택이 없는 게시판은 저장된 stdInfo 에 field_id 가 없어 아래 else 로직을 타지 않기 때문에,
      //  이 블록이 없으면 저장된 작성자 정보가 복원되지 않는다.)
      if (value) {
        if (value.date) this.form.date = value.date;
        if (value.division) this.form.division = value.division;
        if (value.department) this.form.department = value.department;
        if (value.section) this.form.section = value.section;
        if (value.rank) this.form.rank = value.rank;
        if (value.writer_name) this.form.writer_name = value.writer_name;
        if (value.com_name) this.form.com_name = value.com_name;
        if (value.manager_name) this.form.manager_name = value.manager_name;
        if (value.부서명_과) this.form.부서명_과 = value.부서명_과;
      }

      if (typeof value === "undefined" || typeof value.field_id === "undefined") {
        this.form.field_id = 0;
      } else {
        this.form.date = value.date;
        this.form.field_id = value.field_id;
        this.form.field_name = value.field_name;
        this.form.project_name = value.project_name;
        this.form.field_address = value.field_address;
        this.form.부서명_과 = value.부서명_과;
        this.form.division = value.division;
        this.form.department = value.department;
        this.form.section = value.section;
        this.form.com_name = value.com_name;
        this.form.manager_name = value.manager_name;
        this.form.rank = value.rank;
        this.form.writer_name = value.writer_name;
        this.form.검토일 = value.검토일;
        this.form.조사일 = value.조사일;
        this.form.점검일 = value.점검일;
        this.form.보수일 = value.보수일;
        this.form.진단일 = value.진단일;
        this.form.보강일 = value.보강일;
        this.form.교체일 = value.교체일;
        this.form.평가일 = value.평가일;
        this.form.점검장소 = value.점검장소;
        this.form.보수장소 = value.보수장소;
        this.form.재해형태 = value.재해형태;
        this.form.진단장소 = value.진단장소;
        this.form.보강장소 = value.보강장소;
        this.form.교체장소 = value.교체장소;
        this.form.평가자 = value.평가자;
        this.form.공정내용 = value.공정내용;

        this.form.총원 = value.총원;
        this.form.작업내용 = value.작업내용;
        this.form.점검시간 = value.점검시간;
        this.form.작업명 = value.작업명;

        this.form.notification = value.notification;

        // updated_at 추가
        const postId = this.$route.params.postId;
        const boardList = this.$store.state.board.list;
        for (const boardData of boardList) {
          if (boardData.id === postId) {
            this.form.updated_at = boardData.updated_at;
          }
        }
      }

      for (const option of this.options) {
        if (value) {
          this.form[`${option.label}`] = value[`${option.label}`] ? value[`${option.label}`] : "";
        } else {
          this.form[`${option.label}`] = "";
        }
      }
    },
    onSelectFieldSelector(value) {
      this.form.field_name = value.field_name;
      this.form.field_address = value.address;
      this.form.manager_name = value.manager_name;

      this.form.scale1 = value.scale1;
      this.form.scale2 = value.scale2;
      this.form.scale3 = value.scale3;
      if (value.facility_category) {
        this.form.cat1 = value.facility_category.cat1;
        this.form.cat2 = value.facility_category.cat2;
        this.form.cat3 = value.facility_category.cat3;
        this.form.classification = value.facility_category.classification;
      }

      if (value.meta) {
        const meta = JSON.parse(value.meta);

        this.form.com_name = meta.team_company_list ? meta.team_company_list.map((cl) => cl.com_name).join(", ") : "";
        this.form.부서명_과 = meta.com_name;

        this.form.관리주체 = meta.management_entity;
        this.form.관리방법 = meta.관리방법;
        this.form.소관부서 = meta.소관부서;
        this.form.담당주무관 = meta.담당주무관;

        this.$store.commit("menu/SET_LISTSEARCHFILEDNAME", { boardId: this.boardId, name: meta.com_name });
      }

      this.$emit("selectField", value);
    },
    onSelectCompanySelector(value) {
      this.form.company_id = value.id;

      if (value.meta) {
        const meta = JSON.parse(value.meta);
        this.form.com_name = meta.team_company_list.map((cl) => cl.com_name).join(", ");
      }

      this.form.section = value.section || value.com_name;
    },
  },
};
</script>

<style lang="scss" scoped>
.createdby {
  border: solid 1px #cdcdcd;
  border-radius: 5px;
  padding: 22px;

  // PC 레이아웃 (768px 이상)
  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: left;
    gap: 28px;

    & > div > * {
      display: inline-block;
    }
    & > div > b {
      margin-right: 7px;
    }
  }

  // 모바일 레이아웃 (768px 미만)
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 10px 22px;

    & > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      & > b {
        font-weight: 600;
        color: #333;
        margin-right: 0;
        flex-shrink: 0;
      }

      & > p {
        text-align: right;
        margin: 0;
        color: #666;
        flex-grow: 1;
        margin-left: 12px;
      }
    }
  }

  // 인쇄 시 PC 레이아웃 강제 적용
  @media print {
    display: flex !important;
    align-items: center !important;
    justify-content: left !important;
    gap: 28px !important;
    flex-direction: row !important;
    padding: 22px !important;

    & > div {
      display: block !important;
      padding: 0 !important;
      border-bottom: none !important;

      & > * {
        display: inline-block !important;
      }

      & > b {
        margin-right: 7px !important;
        margin-left: 0 !important;
        flex-shrink: initial !important;
        font-weight: 700 !important;
        color: #333 !important;
      }

      & > p {
        text-align: left !important;
        margin: 0 !important;
        color: #666 !important;
        flex-grow: initial !important;
        margin-left: 0 !important;
      }
    }
  }
}
</style>
